module.exports = __webpack_public_path__ + "img/arrow-left-double.c2f79308.svg";